import { render, staticRenderFns } from "./user-detail-modal.vue?vue&type=template&id=1363e6f2&"
import script from "./user-detail-modal.vue?vue&type=script&lang=js&"
export * from "./user-detail-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports